import { AppLocale } from 'src/models/modules';
import { IQuestion, IAnswer } from 'src/entities/question';
import { ICustomerData } from './CustomerData/CustomerData';
import { registerLocale } from 'react-datepicker';

export const toCustomerData = (answers?: IAnswer[]): ICustomerData =>
    answers ?
        answers.reduce<ICustomerData>((acc, a) => {
            return { ...acc, [a.Id]: a.Value }
        }, {})
        : []

export const toAnswers = (questions: IQuestion[], answers: ICustomerData): IAnswer[] =>
    questions.map((q): IAnswer => (
        {
            Id: q.Id,
            Name: q.Name,
            FieldName: q.FieldName,
            Value: (q.IsHidden !== true) ? answers[q.Id] : ''
        }
    ));


export const getDateFnsLocale = async (locale: string): Promise<Locale | undefined> =>
    {
        if (locale === AppLocale.En) { locale = 'en-GB'; }
        return (await import(`date-fns/locale/${locale}`)).default;
    };

export const registerDateFnsLocale = async (name: string) => {
    if (name === AppLocale.En) { name = 'en-GB'; }
    getDateFnsLocale(name).then(locale => locale && registerLocale(name, locale));
}

export const setSelectButtonsToEqualWidth = (className: string) => {
    const keepSelected = document.querySelector<HTMLButtonElement>(`.${className}.button--secondary`);
    const reserve = document.querySelectorAll<HTMLButtonElement>(`.${className}.button--primary`);

    if (keepSelected && reserve) {
        const w1 = keepSelected.getBoundingClientRect().width;
        const w2 = reserve[0].getBoundingClientRect().width;

        const widest = String(Math.max(w1, w2)) + 'px';
        keepSelected.style.width = widest;
        reserve.forEach(node => node.style.width = widest)
    }
}